
<template>
    <div class="modal undo-modal"
        :class="{['minimized']: minimized}">
        <div class="modal-title hide-on-minimized">
            {{ title }}
        </div>
        <div class="modal-content">
            <div class="modal-description">
                {{ description }}
            </div>
            <div class="options">
                <button
                    class="btn btn-3d"
                    :class="{
                        ['btn-primary']: !i,
                        ['btn-muted']: i,
                    }"
                    v-for="(option, i) in options"
                    :key="`option-${option.value}`"
                    @click="onSubmit(option.value)"
                >
                    {{ option.label }}
                </button>
            </div>
        </div>
        <span class="modal-toggle" @click="onToggleMinimize">
            <fa-icon
                icon="window-minimize"
                class="minimize-modal-icon"
                v-if="!minimized"
            />
            <fa-icon
                icon="chevron-up"
                class="maximize-modal-icon"
                v-if="minimized"
            />
        </span>
    </div>
</template>

<script>

export default {
    name: 'UndoModal',
    data() {
        return {
            minimized: false,
            title: 'Undo requested',
        };
    },
    computed: {
        undoState() {
            return this.$store.state.undoState;
        },
        gameId() {
            return parseInt(this.$route.params.id, 10);
        },
        undoApprovalId() {
            return this.undoState.undoApprovalId;
        },
        description() {
            return this.undoState.description;
        },
        options() {
            return this.undoState.options;
        },
    },
    methods: {
        onToggleMinimize() {
            this.minimized = !this.minimized;
        },
        onSubmit(state) {
            const payload = {
                gameId: this.gameId,
                undoApprovalId: this.undoApprovalId,
                state,
            };
            this.$store.dispatch('sendDecision', payload);
        },
    },
};
</script>


<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .undo-modal {
        text-align: center;

        .btn {
            min-width: 75px;

            &:not(:last-of-type) {
                margin-right: 25px;
            }
        }
    }

</style>
